import React from "react";

import Chip from "@mui/material/Chip";

export default function CustomChip(props: any) {
  const { size, label, variant, className } = props;
  return <Chip size={size} label={label} variant={variant} sx={className} />;
}
